<template>
	<div class="visualizer-addtocart">
		<div class="visualizer-terms" v-if="termsGiven">
			<input type="checkbox" id="visualizer--terms" v-model="termsAccepted" />
			<label for="visualizer--terms">
				<span>
					I accept the
					<a :href="magentoData.termsUrl" target="_blank">Terms and conditions</a>
				</span>
			</label>
		</div>
		<div class="tocart-box">
			<div class="qty-wrapper">
				<label class="qty-label" for="visualizer--quantity">Quantity</label>
				<input class="qty" id="visualizer--quantity" type="number" min="1" v-model="quantity" onkeydown="return event.keyCode !== 69" />
			</div>
			<button
				class="tocart"
				id="visualizer--add-to-cart"
				@click="prepareAddToCart"
				:disabled="(termsGiven && !termsAccepted) || quantity < 1 || adding"
				v-text="buttonText"
			></button>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import helper from "@/mixins/helper.js";
import cartItem from "@/mixins/cart-item.js";
import axios from "axios";
import StepValidator from "@/components/StepValidator";

export default {
	name: "AddToCart",
	extends: StepValidator,
	mixins: [helper, cartItem],
	data: function() {
		return {
			cartItem: {},
			termsAccepted: false,
			quantity: 1,
			adding: false,
			buttonText: "Add to Bag"
		};
	},
	computed: {
		...mapState({
			config: state => state.configurator.config,
			selectedOptions: state => state.configurator.selectedOptions,
			magentoData: state => state.configurator.magentoData,
			exportedImage: state => state.configurator.exportedImage,
			currentStep: state => state.configurator.currentStep,
			invalidStep: state => state.configurator.invalidStep
		}),
		termsGiven() {
			return this.magentoData.termsUrl ? this.magentoData.termsUrl.length > 0 : false;
		},
		addToCartHeaders() {
			return {
				headers: {
					"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
				}
			};
		}
	},
	watch: {
		quantity() {
			this.$store.dispatch("configurator/setQuantity", this.quantity);
		}
	},
	methods: {
		addToCartSuccessful() {
			this.$store.dispatch("configurator/increaseAddedToCartAmount");
			var t = document.createEvent("CustomEvent");
			t.initCustomEvent("add-to-cart-success", !0, !0, !0), document.dispatchEvent(t);
			console.log('addToCartSuccessful');
		},
		prepareAddToCart() {
			this.adding = true;
			this.buttonText = "Adding...";
			console.log("Adding product to Cart...");
			if (this.isValidSteps(this.currentStep)) {
				this.cartItem = this.createCartItem();
				//this.cartItem = this.magentoData.options
				this.addToCart();
			} else {
				this.$store.dispatch("configurator/setCurrentStep", this.invalidStep);
			}
		},
		addToCart() {
			if (!this.magentoData.cartApi) {
				this.buttonText = "Cart API URL is not set!";
				console.error("Cart API URL is not set!");
				return;
			}

			let self = this;
			const http = axios.create();

			http.post(self.magentoData.cartApi, this.cartItem, self.addToCartHeaders)
				.then(function() {
					self.addToCartSuccessful();
				})
				.catch(function(error) {
					try {
						self.setError(163, "Error while posting cart items: " + error.response.data.message);
					} catch (e) {
						self.setError(163, "Error while posting cart items.");
					}
				})
				.finally(function() {
					self.buttonText = "Added...Redirecting to Cart";
					self.adding = false;
					setTimeout(() => self.buttonText = "Add to Bag", 3000);
					window.location.replace(self.magentoData.cartUrl)
				});
		}
	}
};
</script>

<style lang="scss" scoped>
a {
	text-decoration: underline;
}

.visualizer-addtocart {
	.visualizer-terms {
		margin: 32px 0;

		input[type="checkbox"] {
			display: none;

			+ label {
				line-height: 28px;
				display: flex;
				vertical-align: top;
				justify-content: center;

				&:before {
					content: "";
					width: 24px;
					min-width: 24px;
					height: 24px;
					border: 1px solid $border-color;
					display: inline-block;
					margin-right: 8px;
					box-shadow: inset 0 0 0 6px #fff;
					transition: box-shadow 0.12s;
					cursor: pointer;
					-webkit-animation-duration: 4s;
					animation-duration: 4s;
					-webkit-animation-iteration-count: infinite;
					animation-iteration-count: infinite;
					-webkit-animation-name: checkboxPulse;
					animation-name: checkboxPulse;
					-webkit-animation-play-state: running;
					animation-play-state: running;
					-webkit-animation-timing-function: linear;
					animation-timing-function: linear;
				}
			}

			&:checked + label:before {
				background: $color-martinique-blue;
				border-color: $color-martinique-blue;
				box-shadow: inset 0 0 0 3px #fff;
				animation: none;
			}
		}
	}

	.tocart-box {
		.qty-wrapper {
			margin: 32px 0;
			text-align: center;

			.qty-label {
				display: block;
				font-weight: bold;
				margin-bottom: 8px;
			}

			.qty {
				width: 120px;
				height: 40px;
				font-size: 1em;
				text-align: center;
			}
		}

		.tocart {
			margin-bottom: 32px;
			display: block;
			width: 100%;
		}
	}

	@-webkit-keyframes checkboxPulse {
		5% {
			-webkit-transform: scale(1.3);
			transform: scale(1.3);
			border-color: $color-martinique-blue;
		}
		8% {
			-webkit-transform: scale(1);
			transform: scale(1);
			border-color: $border-color;
		}
	}
	@keyframes checkboxPulse {
		5% {
			-webkit-transform: scale(1.3);
			transform: scale(1.3);
			border-color: $color-martinique-blue;
		}
		8% {
			-webkit-transform: scale(1);
			transform: scale(1);
			border-color: $border-color;
		}
	}
}
</style>